import React, { ReactNode, useEffect } from "react";
import { useRouter } from "next/router";
import styled from "styled-components";
import { useSession } from "../../../queries/authentication.query";
import { routes } from "../../../routes";
import PageLoader from "../PageLoader/PageLoader";
import { getQueryParam } from "../../../helpers/nextHelper";
import { isAuthPath } from "../../../helpers/routerHelper";

const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow: auto;
  background-image: url(${({ theme }) => theme.backgroundImage});
  background-size: cover;
`;

type RenderChildren = () => ReactNode;

interface IProps {
  children: ReactNode | RenderChildren;
}

const AuthPage = ({ children }: IProps) => {
  const router = useRouter();
  const { isLoggedIn, isFetched } = useSession();

  useEffect(() => {
    if (isFetched && isLoggedIn) {
      const from = getQueryParam(router.query, "from");
      const redirectPath = from && !isAuthPath(from) ? from : routes.home;
      router.replace(redirectPath);
    }
  }, [isFetched, isLoggedIn]);

  if (!isFetched || isLoggedIn) {
    return <PageLoader />;
  }

  return (
    <Wrapper>{typeof children === "function" ? children() : children}</Wrapper>
  );
};

export default AuthPage;
